import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Dialog,
  IconButton,
  Typography,
  colors,
  Divider
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteForever';

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(0, 2),
    maxWidth: 720,
    margin: '0 auto'
  },
  product: {
    overflow: 'unset',
    position: 'relative',
    padding: theme.spacing(5, 3),
    cursor: 'pointer',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  image: {
    borderRadius: theme.shape.borderRadius,
    position: 'absolute',
    top: -24,
    left: theme.spacing(3),
    height: 48,
    width: 48,
    fontSize: 24
  },
  options: {
    lineHeight: '26px'
  },
  recommended: {
    backgroundColor: theme.palette.primary.main,
    '& *': {
      color: `${theme.palette.white} !important`
    }
  },
  contact: {
    margin: theme.spacing(3, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  }
}));

const DeleteModal = props => {
  const { button, buttonIcon, title, content, open, onClose, onDelete, className } = props;

  const classes = useStyles();

  return (
    <Dialog
      classes={{ paper: clsx(classes.root, className) }}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <div className={classes.header}>
        <Typography variant="h3">
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <div className={classes.content}>
        <Typography
          align="center"
          className={classes.contact}
          variant="subtitle1"
        >
          {content}
        </Typography>
      </div>
      <div className={classes.actions}>
        <Button
          className={classes.deleteButton}
          endIcon={buttonIcon}
          onClick={onDelete}
          variant="contained"
        >
          {button}
        </Button>
      </div>
    </Dialog>
  );
};

DeleteModal.propTypes = {
  button: PropTypes.string,
  buttonIcon: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.any,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string
};

DeleteModal.defaultProps = {
  button: 'Delete',
  buttonIcon: <DeleteIcon />,
  title: 'Delete',
  content: 'Are you sure to delete this record?'
}

export default DeleteModal;
